<div class="mt-xl flex">
  <cft-dynamic-icon
    class="plot-xl"
    [icon]="bulletPoint.icon"
    [style]="'color: ' + bulletPoint.iconColor"
  ></cft-dynamic-icon>
  <div class="pl-sm">
    <h3 class="heading-lg">{{ bulletPoint.lead }}</h3>
    @if (bulletPoint.content; as content) {
      <bgo-rich-text [content]="{json: content}"></bgo-rich-text>
    } @else if (bulletPoint.text) {
      <p class="mt-2xs text-base">{{ bulletPoint.text }}</p>
    }
  </div>
</div>
